export default "4e7c5c7ac23d7f7a.woff2"